import React, { memo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { MdCrop } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import { TbReplace } from 'react-icons/tb';
import { ThumbnailActionsProps } from '../types';

const ThumbnailActions = memo(({
	onHover,
	onReplace,
	onDelete,
	onCrop
}: ThumbnailActionsProps) => (
	<Box
		width='100%'
		height='100%'
		sx={{
			position       : 'absolute',
			top            : 0,
			left           : 0,
			display        : 'flex',
			alignItems     : 'center',
			justifyContent : 'center',
			background     : 'rgba(0, 0, 0, 0.6)',
			borderRadius   : '13px'
		}}
	>
		<Stack direction={'column'} alignItems={'center'}>
			<Box width={'36px'} borderRadius={'50%'} onClick={onReplace} bgcolor={'#D9D9D9'} height={'36px'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{ cursor: 'pointer' }}>
				<TbReplace fontSize='var(--pixel20)' />
			</Box>
			<Typography fontSize={'var(--pixel10)'} color={'var(--whiteColor)'}>Replace</Typography>
		</Stack>
		<Stack direction={'column'} px={2.5} alignItems={'center'}>
			<Box width={'36px'} onClick={onDelete} borderRadius={'50%'} bgcolor={'#D9D9D9'} height={'36px'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{ cursor: 'pointer' }}>
				<RiDeleteBinLine fontSize='var(--pixel20)' />
			</Box>
			<Typography fontSize={'var(--pixel10)'} color={'var(--whiteColor)'}>Delete</Typography>
		</Stack>
		<Stack direction={'column'} alignItems={'center'}>
			<Box
				width={'36px'}
				borderRadius={'50%'}
				bgcolor={'#D9D9D9'}
				height={'36px'}
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
				sx={{ cursor: 'pointer' }}
				onClick={onCrop}
			>
				<MdCrop fontSize='var(--pixel20)' />
			</Box>
			<Typography fontSize={'var(--pixel10)'} color={'var(--whiteColor)'}>Crop</Typography>
		</Stack>
	</Box>
));

ThumbnailActions.displayName = 'ThumbnailActions';
export default ThumbnailActions;